import { Inject, Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'any',
})
export class TitleService {
  private _title: string = '';
  private _pointer: string = '';
  private _prefix: string[] = ['زیراکسی'];
  private defaultTitle = "زیراکسی | مجموعه چاپ آنلاین، با کیفیت و ارزان";
  private _titleSubject$!: BehaviorSubject<string>;
  public pointerSubject$: BehaviorSubject<string> = new BehaviorSubject('');

  constructor(@Inject(Title) private titleHandler: Title,
              @Inject(DOCUMENT) private dom: Document,
              @Inject(Meta) private metaService: Meta,) {
    this._titleSubject$ = new BehaviorSubject(this._title);

    this.titleSubject$.subscribe((newTitle) => {
      this.titleHandler.setTitle(newTitle);
    });
  }

  // set title(title: string) {
  //   this._title = title;
  // }

  // get title(): string {
  //   return (
  //     this._prefix.join(' | ') + (!!this._title ? ' | ' + this._title : '')
  //   );
  // }
  set pointer(pointer: string) {
    this._pointer = pointer;
  }

  get pointer(): string {
    return this.pointer;
  }

  get titleSubject$(): Observable<string> {
    return this._titleSubject$.pipe(catchError(() => EMPTY));
  }

  // ----------------------------------------------------Public Methods|

  public setTitle(strTitle: string) {
    this._title = strTitle;
    this.updateTitle();
  }

  /**
   * Adds prefix and returns index.
   * @param prefix
   */
  public addPrefix(prefix: string): number {
    this._prefix.push(prefix);
    this.updateTitle();
    return this._prefix.indexOf(prefix);
  }

  public removePrefix(index: number): void {
    this._prefix.splice(index, 1);
  }

  public getTitle() {
    return this._title;
  }

  public updateTitle() {
    this._titleSubject$.next(this._title);
  }

  public setDefaultTitle() {
    this._titleSubject$.next(this.defaultTitle)
  }

  public setRouterPointer(pointer: string) {
    this.pointerSubject$.next(pointer);
  }

  public updateCanonicalUrl(url:string){
    const head = this.dom.getElementsByTagName('head')[0];
    let element: HTMLLinkElement | null = this.dom.querySelector(`link[rel='canonical']`) || null
    if (element == null) {
      element= this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel','canonical')
    element.setAttribute('href',url)
  }

  updatePageDescription(content: string) {
    if (content) this.metaService.updateTag({ name: 'description', content: content});
  }

  setPublicDescriptionTag() {
    this.metaService.updateTag({ name: 'description', content: "زیراکسی، ارائه دهنده انواع خدمات چاپ با راه حلی بسیار ساده و سریع."});
  }
}
